export class StepperCanActivated {

  canActivate: boolean;
  reason: string;

  constructor() {
  }
}
